import {
  withTranslation,
} from 'react-i18next';

import ChampionshipResultTableFieldsView from './ChampionshipResultTableFieldsView';

const TranslatedComponent = withTranslation()(ChampionshipResultTableFieldsView);

const Component = TranslatedComponent;

export default Component;
